"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class OrganisationManagement extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'organisationManagement';
        this._currency = initParams.currency;
        this._name = initParams.name;
        this._orgCurrency = initParams.org_currency;
        this._stripeId = initParams.stripe_id;
        this._address = initParams.address;
        this._ownerEmail = initParams.owner_email;
        this._dashboardTier = initParams.dashboard_tier;
        this._dashboardTierFrequency = initParams.dashboard_tier_frequency;
        this._paymentMethods = (0, util_1.camelArray)(initParams.payment_methods);
        this._subscriptions = (0, util_1.camelArray)(initParams.subscriptions);
        this._invoices = (0, util_1.camelArray)(initParams.invoices);
        this._acceptedTerms = initParams.accepted_terms;
        this._free = initParams.free;
        this._accountLocked = initParams.account_locked;
        this._subPaymentExempt = initParams.sub_payment_exempt;
        this._lastActive = initParams.last_active;
        this._users = (0, util_1.camelArray)(initParams.users);
        this._deviceCount = initParams.device_count;
        this._appliances = initParams.appliances;
        this._issues = initParams.issues;
        this._sites = initParams.sites;
        this._seats = initParams.seats;
        this._hubCount = initParams.hub_count;
        this._simCount = initParams.sim_count;
    }
    set currency(value) {
        console.error('Do not set objects this way');
    }
    setCurrency(value) {
        return this.dataService.updateOrganisationManagement(this.id, { currency: value }, this);
    }
    get currency() {
        return this._currency;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateOrganisationManagement(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set orgCurrency(value) {
        console.error('Do not set objects this way');
    }
    setOrgCurrency(value) {
        return this.dataService.updateOrganisationManagement(this.id, { org_currency: value }, this);
    }
    get orgCurrency() {
        return this._orgCurrency;
    }
    set stripeId(value) {
        console.error('Do not set objects this way');
    }
    setStripeId(value) {
        return this.dataService.updateOrganisationManagement(this.id, { stripe_id: value }, this);
    }
    get stripeId() {
        return this._stripeId;
    }
    set address(value) {
        console.error('Do not set objects this way');
    }
    setAddress(value) {
        return this.dataService.updateOrganisationManagement(this.id, { address: value }, this);
    }
    get address() {
        return this._address;
    }
    set ownerEmail(value) {
        console.error('Do not set objects this way');
    }
    setOwnerEmail(value) {
        return this.dataService.updateOrganisationManagement(this.id, { owner_email: value }, this);
    }
    get ownerEmail() {
        return this._ownerEmail;
    }
    set dashboardTier(value) {
        console.error('Do not set objects this way');
    }
    setDashboardTier(value) {
        return this.dataService.updateOrganisationManagement(this.id, { dashboard_tier: value }, this);
    }
    get dashboardTier() {
        return this._dashboardTier;
    }
    set dashboardTierFrequency(value) {
        console.error('Do not set objects this way');
    }
    setDashboardTierFrequency(value) {
        return this.dataService.updateOrganisationManagement(this.id, { dashboard_tier_frequency: value }, this);
    }
    get dashboardTierFrequency() {
        return this._dashboardTierFrequency;
    }
    set paymentMethods(value) {
        console.error('Do not set objects this way');
    }
    setPaymentMethods(value) {
        return this.dataService.updateOrganisationManagement(this.id, { payment_methods: (0, util_1.snakeArray)(value) }, this);
    }
    get paymentMethods() {
        return this._paymentMethods;
    }
    set subscriptions(value) {
        console.error('Do not set objects this way');
    }
    setSubscriptions(value) {
        return this.dataService.updateOrganisationManagement(this.id, { subscriptions: (0, util_1.snakeArray)(value) }, this);
    }
    get subscriptions() {
        return this._subscriptions;
    }
    set invoices(value) {
        console.error('Do not set objects this way');
    }
    setInvoices(value) {
        return this.dataService.updateOrganisationManagement(this.id, { invoices: (0, util_1.snakeArray)(value) }, this);
    }
    get invoices() {
        return this._invoices;
    }
    set acceptedTerms(value) {
        console.error('Do not set objects this way');
    }
    setAcceptedTerms(value) {
        return this.dataService.updateOrganisationManagement(this.id, { accepted_terms: value }, this);
    }
    get acceptedTerms() {
        return this._acceptedTerms;
    }
    set free(value) {
        console.error('Do not set objects this way');
    }
    setFree(value) {
        return this.dataService.updateOrganisationManagement(this.id, { free: value }, this);
    }
    get free() {
        return this._free;
    }
    set accountLocked(value) {
        console.error('Do not set objects this way');
    }
    setAccountLocked(value) {
        return this.dataService.updateOrganisationManagement(this.id, { account_locked: value }, this);
    }
    get accountLocked() {
        return this._accountLocked;
    }
    set subPaymentExempt(value) {
        console.error('Do not set objects this way');
    }
    setSubPaymentExempt(value) {
        return this.dataService.updateOrganisationManagement(this.id, { sub_payment_exempt: value }, this);
    }
    get subPaymentExempt() {
        return this._subPaymentExempt;
    }
    set lastActive(value) {
        console.error('Do not set objects this way');
    }
    setLastActive(value) {
        return this.dataService.updateOrganisationManagement(this.id, { last_active: value }, this);
    }
    get lastActive() {
        return this._lastActive;
    }
    set users(value) {
        console.error('Do not set objects this way');
    }
    setUsers(value) {
        return this.dataService.updateOrganisationManagement(this.id, { users: (0, util_1.snakeArray)(value) }, this);
    }
    get users() {
        return this._users;
    }
    set deviceCount(value) {
        console.error('Do not set objects this way');
    }
    setDeviceCount(value) {
        return this.dataService.updateOrganisationManagement(this.id, { device_count: value }, this);
    }
    get deviceCount() {
        return this._deviceCount;
    }
    set appliances(value) {
        console.error('Do not set objects this way');
    }
    setAppliances(value) {
        return this.dataService.updateOrganisationManagement(this.id, { appliances: value }, this);
    }
    get appliances() {
        return this._appliances;
    }
    set issues(value) {
        console.error('Do not set objects this way');
    }
    setIssues(value) {
        return this.dataService.updateOrganisationManagement(this.id, { issues: value }, this);
    }
    get issues() {
        return this._issues;
    }
    set sites(value) {
        console.error('Do not set objects this way');
    }
    setSites(value) {
        return this.dataService.updateOrganisationManagement(this.id, { sites: value }, this);
    }
    get sites() {
        return this._sites;
    }
    set seats(value) {
        console.error('Do not set objects this way');
    }
    setSeats(value) {
        return this.dataService.updateOrganisationManagement(this.id, { seats: value }, this);
    }
    get seats() {
        return this._seats;
    }
    set hubCount(value) {
        console.error('Do not set objects this way');
    }
    setHubCount(value) {
        return this.dataService.updateOrganisationManagement(this.id, { hub_count: value }, this);
    }
    get hubCount() {
        return this._hubCount;
    }
    set simCount(value) {
        console.error('Do not set objects this way');
    }
    setSimCount(value) {
        return this.dataService.updateOrganisationManagement(this.id, { sim_count: value }, this);
    }
    get simCount() {
        return this._simCount;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateOrganisationManagement(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = OrganisationManagement;
//# sourceMappingURL=organisationManagement.js.map